import React from 'react';
import { useIsUserActingAsATMStore, useSelectedDateStore } from '../../../CalendarStore';
import LabeledSwitch from '@shared/components/LabeledSwitch';
import { useShallow } from 'zustand/shallow';

const TITLE = 'Calendar View';

/**
 * @typedef {object} ViewSwitchProps
 * @property {string} activeLabel
 */

/**
 * @param {ViewSwitchProps} props
 */
const ViewSwitch = props => {
  const { activeLabel } = props;

  const isUserActingAsATM = useIsUserActingAsATMStore(useShallow(state => state.isUserActingAsATM));
  const toggleIsUserActingAsATM = useIsUserActingAsATMStore.getState().toggleIsUserActingAsATM;

  const resetSelectedDate = useSelectedDateStore.getState().resetSelectedDate;

  const onChangeHandler = () => {
    if (!isUserActingAsATM) {
      resetSelectedDate();
    }

    toggleIsUserActingAsATM();
  };

  return (
    <LabeledSwitch
      title={TITLE}
      checkedLabel={activeLabel}
      uncheckedLabel={activeLabel}
      onChange={onChangeHandler}
      checked={!isUserActingAsATM}
      testId='calendar-switcher'
    />
  );
};

export default ViewSwitch;
